const resources = {
    title: 'Same-Day Delivery Instructions',
    optional: '(Optional)',
    cancel: 'Cancel',
    saveInstructions: 'Save Instructions',
    edit: 'Edit',
    textInputLabel: 'Exemple : Veuillez entrer le code de la porte à votre arrivée.',
    deliveryNote: 'Nous laisserons vos articles à votre porte si vous n’êtes pas là au moment de la livraison.'
};

export default function getResource(label) {
    return resources[label];
}
